<template>
  <DefaultTemplate positionNavNextTo="right" type="signup">
    <div class="box-container pd-y-1">
      <Header title="ลืมรหัสผ่าน" class="forgetPass" />
      <p class="text-font-16 mg-y-less">
        โปรดระบุอีเมลที่ท่านใช้สมัครสมาชิก เว็บไซต์จะจัดส่ง ลิงค์สำหรับเปลี่ยน
      </p>
      <p class="text-font-16 mg-y-less pd-b-3">
        รหัสผ่าน ให้ท่านทางอีเมลที่ลงทะเบียนไว้
      </p>
      <el-form
        @submit.prevent.native
        label-position="top"
        class="text-left pd-b-1 box-sandemail"
        ref="formForgot"
        :model="formForgot"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label prop="email">
              <el-input
                v-model="formForgot.email"
                @keyup.enter.native="forgot"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="pd-y-3">
            <el-button type="primary" class="width-100" round @click="forgot()"
              >ส่งอีเมล</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
  </DefaultTemplate>
</template>

<script>
import DefaultTemplate from "@/template/DefaultTemplate";
import Header from "@/components/template/Header";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DefaultTemplate,
    Header,
  },
  data() {
    return {
      formForgot: {
        email: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "กรุณากรอกอีเมล",
            trigger: "blur",
          },
          {
            type: "email",
            message: "กรุณากรอกอีเมลให้ถูกต้อง",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    forgot() {
      this.$refs["formForgot"].validate((valid) => {
        if (valid) {
          let obj = {
            email: this.formForgot.email,
          };
          HTTP.post(`forgot/password`, obj)
            .then((res) => {

              if (res.data.success) {
                this.$message({
                  message: "ระบบส่งการตั้งรหัสผ่านใหม่ให้ในอีเมลแล้ว กรุณาตรวจสอบอีเมล",
                  type: "success",
                });
                this.$router.push("/");
              } else {
                if (res.data.data == "The system account is not used.") {
                  this.$message({
                    message: "คุณสมัครสมาชิกโดยใช้ช่องทาง Facebook หรือ Gmail จึงไม่สามารถเปลี่ยนรหัสผ่านได้",
                    type: "error",
                  });
                } else if (res.data.data == "Not found user.") {
                  this.$message({
                    message: "อีเมลนี้ยังไม่ได้ลงทะเบียนในระบบ",
                    type: "error",
                  });
                } else {
                  this.alertFailError();
                }
              }
            })
            .catch((e) => {
              this.alertCatchError(e);
              console.log("Forgot Password error", e);
            })
            .finally(() => {});
        }
      });
    },
  },
};
</script>

<style scoped></style>
